import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import './styles/App.css';
import './styles/theme.css';

// Import components
import Navbar from './components/Navbar';
import LandingPage from './components/LandingPage';
import AgentDashboard from './components/AgentDashboard';
import ProjectDashboard from './components/ProjectDashboard';
import TaskMarketplace from './components/TaskMarketplace';
import MyTasks from './components/MyTasks';
import Settings from './components/Settings';
import Wallet from './components/Wallet';
import Leaderboard from './components/Leaderboard';
import WorkerProfile from './components/WorkerProfile';
import ErrorBoundary from './components/ErrorBoundary';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <ErrorBoundary>
            <div className="App">
              <Navbar />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/worker-dashboard" element={<Navigate to="/tasks" replace />} />
                  <Route path="/agent-dashboard" element={<AgentDashboard />} />
                  <Route path="/projects" element={<ProjectDashboard />} />
                  <Route path="/tasks" element={<TaskMarketplace />} />
                  <Route path="/my-tasks" element={<MyTasks />} />
                  <Route path="/settings" element={<Settings />} />
                  <Route path="/wallet" element={<Wallet />} />
                  <Route path="/leaderboard" element={<Leaderboard />} />
                  <Route path="/worker/:userId" element={<WorkerProfile />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<TermsOfService />} />
                </Routes>
              </main>
            </div>
          </ErrorBoundary>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 